import { InjectionToken, type Provider, inject } from '@angular/core';
import type { UiAccordionConfig } from './accordion.interface';

export const defaultUiAccordionConfig: UiAccordionConfig = {
    type: 'single',
    collapsible: false,
    orientation: 'vertical'
};

export const uiAccordionConfigToken = new InjectionToken<UiAccordionConfig>('[uiAccordionConfigToken] - Accordion config token');

/**
 * Provide the default Accordion configuration
 * @param config The Accordion configuration
 * @returns The provider
 */
export function provideUiAccordionConfig(config: Partial<UiAccordionConfig>): Provider[] {
    return [
        {
            provide: uiAccordionConfigToken,
            useValue: { ...defaultUiAccordionConfig, ...config }
        }
    ];
}

/**
 * Inject the Accordion configuration
 * @returns The global Accordion configuration
 */
export function injectUiAccordionConfig(): UiAccordionConfig {
    return inject(uiAccordionConfigToken, { optional: true }) ?? defaultUiAccordionConfig;
}
